import { Component, OnInit, EventEmitter, Input, Output, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Observable } from 'rxjs/Observable';

import { ArticoloService } from './../../../services/articolo.service';

@Component({
  selector: 'app-alfresco-articolo-selector',
  templateUrl: './alfresco-articolo-selector.component.html',
  styleUrls: ['./alfresco-articolo-selector.component.css'],
  providers: [
    ArticoloService,
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => AlfrescoArticoloSelectorComponent),
      multi: true
    }
  ]
})
export class AlfrescoArticoloSelectorComponent implements OnInit {
  items: Observable<any[]>;
  selected: string;
  loading: boolean;
  editing: boolean;

  @Input() anno: number;
  @Input() numero: number;
  @Input() placeholder: string;
  @Input() required: boolean = false;
  @Output() notify: EventEmitter<string> = new EventEmitter<string>();

  @Input() eraseable: boolean;
  @Output() removeNotify: EventEmitter<any> = new EventEmitter<any>();


  constructor(private service: ArticoloService) { }

  onChange(e: any) {
    // this.notify.emit(e)
    // this.propagateChange(e);
    console.log(e);
        this.editing = false;
        if(e.value) {
          this.selected =  e.value.id + '/' + e.value.name;
          this.propagateChange(this.selected);
        }
  }

  compareWithFn = function(o1: string, o2: string) {
    let match = o1 && o2 ? o1 == o2 : false;
    if (match) {
      if (this.notify) {
        this.notify.emit(o1);
      }
    }
    return match;
  }.bind(this);

  ngOnInit() {  }

  load() {
    if (this.anno && this.numero) {
      this.editing = true;
      this.loading = true;
      this.items = this.service.callAlfrescoEndpoint(this.anno, this.numero).map(result => {
        this.loading = false;
        console.log(result);
        if (result.result) {
          return result.result;
        }
      })
    }
  }

  eraseMe() {
    this.removeNotify.emit();
  }

  private propagateChange = (_: any) => { };

  public writeValue(obj: string) {
    console.log('writeValue', obj)
    if (obj) {
      this.selected = obj
    }
  }

  public registerOnChange(fn: any) {
    this.propagateChange = fn;
  }

  public registerOnTouched() { }
}



// WEBPACK FOOTER //
// ./src/app/components/articolo/alfresco-articolo-selector/alfresco-articolo-selector.component.ts